// extracted by mini-css-extract-plugin
export default {"label":"AddNewMember_label__6aBnN","groupButton":"AddNewMember_groupButton__GlyV6","btnConfirm":"AddNewMember_btnConfirm__x8PmN","btnCancel":"AddNewMember_btnCancel__57-bl"};